export const loadLottie = require('bundle-loader?lazy&name=[name]!lottie-web/build/player/lottie.min');